import Header from './components/Header';
import Hero from './components/Hero';
import CardsSection from './components/CardsSection';
import CommentsSection from './components/CommentsSection';
import CarouselSection from './components/CarouselSection';
import FeaturesSection from './components/FeaturesSection';
import IndexSection from './components/IndexSection';
import AboutSection from './components/AboutSection';
import FaqSection from './components/FaqSection';
import UpdatesSection from './components/UpdatesSection';
import MediaSection from './components/MediaSection';
import TopicsSection from './components/TopicsSection';
import AppSection from './components/AppSection';
import RankingSection from './components/RankingSection';
import ContactSection from './components/ContactSection';
import Footer from './components/Footer';

export default function Home() {
  return (
    <>
      <Header />
      <main>
        <Hero />
        <CardsSection />
        <CommentsSection />
        <CarouselSection />
        <FeaturesSection />
        <IndexSection />
        <AboutSection />
        <FaqSection />
        <UpdatesSection />
        <MediaSection />
        <TopicsSection />
        <AppSection />
        <RankingSection />
        <ContactSection />
      </main>
      <Footer />
    </>
  );
}